/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 다이얼로그 위치 컴포넌트
 * 버전 : 1.0
 * 파일명 : DialogLocation.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 

 *================================================================
 */

import styled from 'styled-components'
import RegionSelector from '../common/RegionSelector'
import { NextButton, NextButtonWrapper } from '../common/CommonStyled'
import { useDialogStore } from 'src/stores/DialogStore'
import { submitPromoFilter } from './useSubmitPromoFilter'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 80px;
    
    padding: 20px 24px;
`

const TitleWrapper = styled.span`
    font-size:16px;
    font-weight:500;
`

const DialogLocation = () => {
    const locations = useDialogStore((state)=>state.locations)
    const setRegions = useDialogStore((state)=>state.setRegions)
    const isValid = !locations || Object.keys(locations).length === 0
    const resetField = useDialogStore((state)=>state.resetField)
    const handleSubmit = async () => {
        await setRegions()
        submitPromoFilter()
    }
    
  return (
    <PageWrapper>
        <TitleWrapper>
            지역
        </TitleWrapper>
        <RegionSelector/>
        <NextButtonWrapper $isBorder={false}>
            <NextButton style={{background:'#F5F5F5', color:'#7F7F89', minWidth:'90px', width:'90px', boxShadow:'none', border:'1px solid #00001480'}} onClick={()=>resetField('locations')}>초기화</NextButton>
            <NextButton onClick={handleSubmit} disabled={isValid} style={{margin:'5px',padding:'10px', height:'46px', boxShadow:'none'}}>적용</NextButton>
        </NextButtonWrapper>
    </PageWrapper>
)
}

export default DialogLocation